import React from 'react'
import './Landing.css'

const Landing: React.FC = () => (
  <main className="landing-page">
    <div className="landing-atmosphere" aria-hidden="true">
      <div className="landing-aura landing-aura-primary" />
      <div className="landing-aura landing-aura-secondary" />
      <div className="landing-orbit landing-orbit-outer" />
      <div className="landing-orbit landing-orbit-inner" />
      <div className="landing-horizon" />
    </div>

    <section className="landing-hero" aria-labelledby="landing-title">
      <div className="landing-emblem">
        <div className="landing-emblem-halo" aria-hidden="true" />
        <img src="/hexacat.svg" alt="" className="landing-symbol" />
      </div>

      <p className="landing-overline">NUOHOUKSEN KOHDEHALLINTA</p>
      <h1 id="landing-title" className="landing-title">HEXACAT<span className="landing-title-period">.</span></h1>
    </section>

    <footer className="landing-footer">
      <span className="landing-footer-line" aria-hidden="true" />
      Nuohous- ja ilmastointipalvelut Knuutila
      <span className="landing-footer-line" aria-hidden="true" />
    </footer>
  </main>
)

export default Landing
